import { render, staticRenderFns } from "./SorterEdit.vue?vue&type=template&id=0f812f62&scoped=true&"
import script from "./SorterEdit.vue?vue&type=script&lang=js&"
export * from "./SorterEdit.vue?vue&type=script&lang=js&"
import style0 from "./SorterEdit.vue?vue&type=style&index=0&id=0f812f62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f812f62",
  null
  
)

export default component.exports